import React from "react";
import { useLocation } from "react-router-dom";
import Refresh_img from "../Header/Refresh_img.png"; // Adjust the path accordingly
import hamburgerMenuImg from "../Sidebar3/HamburgerMenu_img.png"; // Import the hamburger menu image
import Filter_icon from "../Header/Filter_icon.png"; // Import the filter icon image
import "./Header.css"; // Import the CSS file

const Header = ({ refreshPage, toggleFilterSidebar, toggleSidebar }) => {
  const location = useLocation();

  const getTitle = () => {
    switch (location.pathname) {
      case "/D01_Demographics":
        return "Survey Demographics";
      case "/signinillustration":
        return "Signin Illustration";
      case "/landingpage":
        return "Landing Page";
      case "/discover":
        return "Discover";
      case "/compose":
        return "Compose";
      case "/analyze":
      case "/analyze2":
      case "/analyze3":
      case "/analyze4":
        return "Analyze";
      case "/D02_Overall_Engagement":
        return "Overall Engagement";
      case "/D03_Engagement_Summary":
        return "Engagement Summary";
      case "/D04_Responses_by_Demographic_Category":
        return "Responses by Demographic Category";
      case "/D05_Response_Distribution":
        return "Response Distribution";
      case "/D06_Detailed_Scores_by_Demographic_Category":
        return "Detailed Scores by Demographic Category";
      case "/D07_Range_of_Responses":
        return "Range of Responses";
      case "/D08_Self_Reported_Engagement":
        return "Self Reported Engagement";
      case "/D09_Engagement_Questions_Sorted":
        return "Engagement Questions Sorted";
      case "/D10_Open_Text_Responses":
        return "Open Text Responses";
      case "/D11_Open_Text_Heatmap":
        return "Open Text Heat Map";
      case "/D12_Engagement_Areas_by_Impact":
        return "Engagement Areas by Impact";
      case "/D13_Survey_Specific_Questions":
        return "Survey Specific Questions";
      case "/D14_Year_over_Year_by_Area":
        return "Year Over Year by Area";
      case "/D15_Year_over_Year_by_Question": // Added D15
        return "Year Over Year by Question";
      case "/D16_Year_over_Year_Self_Reported": // Added D15
        return "Year Over Year Self Reported"; 
      case "/D17_Open_Text_Top_Themes":
        return "Open Text Top Themes";
      case "/generatereport":
        return "Generate Report";
      default:
        return "Page";
    }
  };

  const showFilterButton = location.pathname !== "/";

  return (
    <header className="header-container">
      <button
        onClick={() => {
          console.log("Sidebar toggle clicked");
          toggleSidebar();
        }}
        className="toggle-sidebar-btn"
      >
        <img src={hamburgerMenuImg} alt="Sidebar" className="sidebar-img" />
      </button>
      <h1 className="header-title">{getTitle()}</h1>
      <div className="header-buttons">
        {showFilterButton && (
          <button
            onClick={() => {
              console.log("Filter sidebar toggle clicked");
              toggleFilterSidebar();
            }}
            className="toggle-filter-sidebar-btn"
          >
            <img src={Filter_icon} alt="Filter" className="filter-icon-img" />
          </button>
        )}
        <button onClick={refreshPage} className="refresh-button">
          <img src={Refresh_img} alt="Refresh" />
        </button>
      </div>
    </header>
  );
};

export default Header;
